// extracted by mini-css-extract-plugin
export default {"layerThree":"layer-three_layerThree__x0em3","layerThreeSvg":"layer-three_layerThreeSvg__MklXl","path":"layer-three_path__PXPO4"};